import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll to the top on every route (pathname) change so pages
// always open from the top. Keyed on pathname only, so in-page hash anchors
// (e.g. "#services") still work normally.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
